import { FaLinkedinIn } from "react-icons/fa6";
import { TbBrandFiverr } from "react-icons/tb";
import { SiUpwork } from "react-icons/si";

const SocialMedia = () => (
  <div className="app__social">
    
    <div>
      <a 
        href="https://www.linkedin.com/in/thesaifrehman" 
        target="_blank" 
        rel="noopener noreferrer"
      >
        <FaLinkedinIn />
      </a>
    </div>

    <div>
      <a 
        href="https://www.fiverr.com/saif_khan02" 
        target="_blank" 
        rel="noopener noreferrer"
      >
        <TbBrandFiverr />
      </a>
    </div>

    <div>
      <a 
        href="https://www.upwork.com/freelancers/~016a4103617d322938" 
        target="_blank" 
        rel="noopener noreferrer"
      >
        <SiUpwork />
      </a>
    </div>

  </div>
);

export default SocialMedia;